/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "../../../utils/helpers/pagination";

export default {
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_DETAIL(state, schedule) {
    state.selecting = schedule;
  },
  UPDATE_SCHEDULE(state, schedule) {
    const userIndex = state.list.findIndex((u) => u.id === schedule.id);
    if (userIndex >= 0) Object.assign(state.list[userIndex], schedule);
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const pos = state.list.findIndex((u) => u.id === item);
        state.list.splice(pos, 1);
      });
    } else {
      const pos = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(pos, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },

  SET_FILTERS(state, data) {
    state.filters = data;
  },

  //Classes sẽ được loại bỏ những class có group_id
  SET_CLASSES(state, data) {
    state.classes = data;
    state.classesWithoutGroups = data.filter((item) => {
      return item.group_id === null || item.group_id === undefined;
    });
  },

  SET_COURSES(state, data) {
    state.courses = data;
  },
};
